import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { AuthGuard } from './helpers/auth.guard';
import { PackComponent } from './components/pack/pack.component';
import { DetailPackComponent } from './components/pack/detail-pack/detail-pack.component';
import { InventoryComponent } from './components/inventory/inventory.component';
import { OrderCountComponent } from './components/order-count/order-count.component';
import { ProductionOrderMovementComponent } from './components/production-order-movement/production-order-movement.component';
import { ProductionOrderFinalizationComponent } from './components/production-order-finalization/production-order-finalization.component';
import { CountDetailsComponent } from './components/production-order-movement/count-details/count-details.component';
import { CountItemsComponent } from './components/production-order-movement/count-items/count-items.component';
import { FinalizationCountItemsComponent } from './components/production-order-finalization/finalization-count-items/finalization-count-items.component';
import { BatchItemLocationComponent } from './components/batch-item-location/batch-item-location.component';
import { BatchItemDetailsComponent } from './components/batch-item-details/batch-item-details.component';
import { DepartureComponent } from './components/departure/departure.component';
import { DepartureConferenceComponent } from './components/departure/departure-conference/departure-conference.component';
import { LooseComponent } from './components/loose/loose.component';
import { LooseConferenceComponent } from './components/loose/loose-conference/loose-conference.component';
import { ProductValueQueryComponent } from './components/product-value-query/product-value-query.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'home', canActivate: [AuthGuard], component: HomeComponent },
  { path: 'contagem', canActivate: [AuthGuard], component: OrderCountComponent, data: { checkMenu: true } },
  { path: 'embarque', canActivate: [AuthGuard], component: DepartureComponent, data: { checkMenu: true } },
  { path: 'avulsa', canActivate: [AuthGuard], component: LooseComponent, data: { checkMenu: true } },
  { path: 'pack', canActivate: [AuthGuard], component: PackComponent, data: { checkMenu: true } },
  { path: 'detail-pack', canActivate: [AuthGuard], component: DetailPackComponent },
  { path: 'balanco', canActivate: [AuthGuard], component: InventoryComponent, data: { checkMenu: true } },
  { path: 'production-order-movement', canActivate: [AuthGuard], component: ProductionOrderMovementComponent, data: { checkMenu: true } },
  { path: 'count-details/:branchCode/:countCode', canActivate: [AuthGuard], component: CountDetailsComponent },
  { path: 'count-items',canActivate: [AuthGuard], component: CountItemsComponent},
  { path: 'batch-item-location', canActivate: [AuthGuard], component: BatchItemLocationComponent },
  { path: 'batch-item-details', canActivate: [AuthGuard], component: BatchItemDetailsComponent },
  { path: 'production-order-finalization', canActivate: [AuthGuard], component: ProductionOrderFinalizationComponent, data: { checkMenu: true } },
  { path: 'finalization-count-items', canActivate: [AuthGuard], component: FinalizationCountItemsComponent },
  { path: 'consulta-preco', canActivate: [AuthGuard], component: ProductValueQueryComponent, data: { checkMenu: true } },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: 'not-found', component: NotFoundComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],  // Configurando o roteamento
  exports: [RouterModule]
})
export class AppRoutingModule { }
